<template lang="pug">
#home
  //- menu title
  .d-flex.flex-row.justify-content-center.mb-1
    .page-title メニュー
  .mb-3.separator

  //- menu list
  b-card.mb-1(no-body v-if="_showCard")
    //- reservations
    template(v-if="(showMenu('reservation') || showMenu('onlineReservation')) && useFunction('reservationsFunction')")
      b-card-header#menu-reservation.p-1(header-tag="header" role="tab" v-b-toggle.accordion-menu-reservation header-class="accordion-toggle")
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            img.mr-3(src="@/assets/sidemenu/reservation.svg")
            span.mr-1 面会予約
            b-badge(v-if="unconsentedReservationCount" pill variant="danger") {{ _unconsentedReservationCount }}
          .toggle-text.mr-1
      b-collapse#accordion-menu-reservation(accordion="reservation-accordion" role="tabpanel")
        b-card-body.p-3
          router-link(:to="urls.ReservationList")
            .menu-item.mb-0
              span.mr-1 面会予約一覧
              b-badge(v-if="unconsentedReservationCount" pill variant="danger") {{ _unconsentedReservationCount }}
    //- outings
    template(v-if="showOuting && showMenu('outing') && useFunction('outingsFunction')")
      b-card-header#menu-outing.p-1(header-tag="header" role="tab" v-b-toggle.accordion-menu-outing header-class="accordion-toggle")
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            img.mr-3(src="@/assets/sidemenu/outing.svg")
            span.mr-1 外出外泊届け
            b-badge(v-if="unconsentedOutingCount" pill variant="danger") {{ _unconsentedOutingCount }}
          .toggle-text.mr-1
      b-collapse#accordion-menu-outing(accordion="outing-accordion" role="tabpanel")
        b-card-body.p-3
          router-link(:to="urls.OutingList")
            .menu-item.mb-0
              span.mr-1 外出外泊届け一覧
              b-badge(v-if="unconsentedOutingCount" pill variant="danger") {{ _unconsentedOutingCount }}
    
    //- menu send message
    template(v-if="useFunction('sendMessagesFunction')")
      b-card-header#menu-send-message.p-1(header-tag="header" role="tab" v-b-toggle.accordion-menu-send-message header-class="accordion-toggle")
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            img.mr-3(src="@/assets/sidemenu/sendmessage.svg")
            span.mr-1 メッセージ送信
            img.send-message-badge(v-show="_showSendMessageIncoming" src="@/assets/sidemenu-sendmessage-incoming.png")
          .toggle-text.mr-1
      b-collapse#accordion-menu-send-message(accordion="send-message-accordion" role="tabpanel")
        b-card-body.p-3
          router-link(v-if="_showSendMessages" :to="urls.MessageRegisterInput")
            .menu-item.mb-2 新規送信
          router-link(:to="urls.FamilyMessageList")
            .menu-item(:class="[showOtherUserGroup ? 'mb-2' : 'mb-0']")
              span.mr-1 履歴（家族）
              img.send-message-badge(v-show="showFamilySendMessageIncoming" src="@/assets/sidemenu-sendmessage-incoming.png")
          router-link(v-if="showOtherUserGroup" :to="urls.OtherUserMessageList")
            .menu-item.mb-0
              span.mr-1 履歴（施設関係者）
              img.send-message-badge(v-show="showOtherUserSendMessageIncoming" src="@/assets/sidemenu-sendmessage-incoming.png")
    //- menu receive message
    template(v-if="showReceiveMessage && useFunction('receiveMessagesFunction')")
      b-card-header#menu-receive-message.p-1(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-menu-receive-message)
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            img.mr-3(src="@/assets/sidemenu/receivemessage.svg")
            span.mr-1 受信メッセージ
            b-badge(v-if="_nonFinishedOpinion" pill variant="danger") {{ _nonFinishedOpinionCount }}
          .toggle-text.mr-1
      b-collapse#accordion-menu-receive-message(accordion="receive-message-accordion" role="tabpanel")
        b-card-body.p-3
          router-link(v-if="showMenu('opinion')" :to="urls.FamilyReceiveMessageList")
            .menu-item.d-flex.flex-row.align-items-center(:class="[showOtherUserGroup ? 'mb-2' : 'mb-0']")
              span.mr-1 家族からの連絡
              b-badge(v-if="nonFinishedFamilyOpinionCount" pill variant="danger") {{ _nonFinishedFamilyOpinionCount }}
          router-link(v-if="showOtherUserGroup" :to="urls.OtherUserReceiveMessageList")
            .menu-item.mb-0.d-flex.flex-row.align-items-center
              span.mr-1 施設関係者からの連絡
              b-badge(v-if="nonFinishedOtherUserOpinionCount" pill variant="danger") {{ _nonFinishedOtherUserOpinionCount }}
    //- menu safety confirm
    template(v-if="showSafetyConfirm && useFunction('safetyConfirmationFunction')")
      b-card-header#menu-safety-confirm.p-1(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-menu-safety-confirm)
        .d-flex.flex-row.align-items-center
          .flex-grow-1
            img.mr-3(src="@/assets/sidemenu/safetyconfirm.svg")
            span.mr-1 安否確認
          .toggle-text.mr-1
      b-collapse#accordion-menu-safety-confirm(accordion="safety-confirm-accordion" role="tabpanel")
        b-card-body.p-3
          router-link(:to="urls.SafetyConfirmList")
            .menu-item.d-flex.flex-row.align-items-center.mb-2
              span.mr-1 安否確認一覧
          router-link(:to="urls.SafetyConfirmOtherUserTempleteInput")
            .menu-item.d-flex.flex-row.align-items-center.mb-2
              span.mr-1 施設関係者の事前設定
          router-link(:to="urls.SafetyConfirmRegisterInput")
            .menu-item.d-flex.flex-row.align-items-center
              span.mr-1 新規作成
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { MobileUrl } from "@/commons/constants/MobileUrl";
import SystemError from "@/commons/models/SystemError";

import SendMessageRepliesService, { SendMessageRepliesUnreadModel } from "@/commons/services/SendMessageReplies";
import OtherUserGroupSendMessageRepliesService from "@/commons/services/OtherUserGroupSendMessageReplies";
import OpinionsService from "@/commons/services/Opinions";
import OtherUserOpinionsService from "@/commons/services/OtherUserOpinions";
import ReservationsService, { ReservationsGetModel } from "@/commons/services/Reservations";
import OutingsService, { OutingGetModel } from "@/commons/services/Outings";
import { PlanType } from "@/commons/services/Plans";

/**
 * ### ホームコンポーネント
 */
@Component({})
export default class Home extends Vue {
  /** メッセージ送信の返信サービス */
  @Inject("SendMessageRepliesService") sendMessageRepliesService!: SendMessageRepliesService;
  /** メッセージ送信の返信サービス */
  @Inject("OtherUserGroupSendMessageRepliesService") otherUserGroupSendMessageRepliesService!: OtherUserGroupSendMessageRepliesService;
  /** 意見サービス */
  @Inject("OpinionsService") opinionsService!: OpinionsService;
  /** 意見サービス */
  @Inject("OtherUserOpinionsService") otherUserOpinionService!: OtherUserOpinionsService;
  /** 面会予約サービス(複数) */
  @Inject("ReservationsService") reservationsService!: ReservationsService;
  /** 外出外泊届けサービス */
  @Inject("OutingsService") outingsService!: OutingsService;

  /** templateで使用するので、importしたUrlクラスをdataとして保持する */
  urls: {} = MobileUrl;

  /** 履歴（家族）の未読が存在するか */
  showFamilySendMessageIncoming: boolean = false;
  /** 履歴（施設関係者）の未読が存在するか */
  showOtherUserSendMessageIncoming: boolean = false;
  /** 未確認の意見数 */
  nonFinishedFamilyOpinionCount: number = 0;
  /** 未確認の意見数 */
  nonFinishedOtherUserOpinionCount: number = 0;
  /** オンライン予約の未承諾数 */
  unconsentedReservationCount: number = 0;
  /** 外出外泊の未承諾数 */
  unconsentedOutingCount: number = 0;

  get _showCard(): boolean {
    const useReservations: boolean = this.useFunction("reservationsFunction");
    const useSendMessages: boolean = this.useFunction("sendMessagesFunction");
    const useReceiveMessages: boolean = this.useFunction("receiveMessagesFunction");
    const useSafetyConfirm: boolean = this.useFunction("safetyConfirmationFunction");

    return useReservations || useSendMessages || useReceiveMessages || useSafetyConfirm;
  }

  get _unconsentedReservationCount(): string {
    // 100件以上の場合は!を格納する
    if (100 <= this.unconsentedReservationCount) {
      return "!";
    } else {
      return String(this.unconsentedReservationCount);
    }
  }

  get _unconsentedOutingCount(): string {
    // 100件以上の場合は!を格納する
    if (100 <= this.unconsentedOutingCount) {
      return "!";
    } else {
      return String(this.unconsentedOutingCount);
    }
  }

  get _showSendMessageIncoming(): boolean {
    if (this.showFamilySendMessageIncoming == true || this.showOtherUserSendMessageIncoming == true) {
      return true;
    }
    return false;
  }

  get _nonFinishedOpinion(): boolean {
    if (0 < this.nonFinishedFamilyOpinionCount || 0 < this.nonFinishedOtherUserOpinionCount) {
      return true;
    }
    return false;
  }

  get _nonFinishedOpinionCount(): string {
    // 100件以上の場合は!を格納する
    if (100 <= this.nonFinishedFamilyOpinionCount + this.nonFinishedOtherUserOpinionCount) {
      return "!";
    } else {
      return String(this.nonFinishedFamilyOpinionCount + this.nonFinishedOtherUserOpinionCount);
    }
  }

  get _nonFinishedFamilyOpinionCount(): string {
    // 100件以上の場合は!を格納する
    if (100 <= this.nonFinishedFamilyOpinionCount) {
      return "!";
    } else {
      return String(this.nonFinishedFamilyOpinionCount);
    }
  }

  get _nonFinishedOtherUserOpinionCount(): string {
    // 100件以上の場合は!を格納する
    if (100 <= this.nonFinishedOtherUserOpinionCount) {
      return "!";
    } else {
      return String(this.nonFinishedOtherUserOpinionCount);
    }
  }

  get showOuting(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.FREE != planType) {
      return true;
    } else {
      return false;
    }
  }

  get showOtherUserGroup(): boolean {
    if (PlanType.BASIC <= userStore.facility.planType) {
      return true;
    } else {
      return false;
    }
  }

  get showReceiveMessage(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      if (userStore.facility.permittedFunctions.opinion == true) {
        return true;
      } else {
        return false;
      }
    }
  }

  get showSafetyConfirm(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.BASIC == planType) {
      return true;
    } else {
      return false;
    }
  }

  get _showSendMessages(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendAndReply;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.getNotificationBadge();

    return;
  }

  /**
   * ### メニューで表示するバッジのための情報を取得
   *
   * - バッジの更新でシステムエラーにはしないため、コンソールエラーだけにする
   */
  public async getNotificationBadge(): Promise<void> {
    Promise.all([
      // 更新が完了次第画面を更新するため非同期で呼び出す
      this.updateUnconsentedReservationCount(),
      this.updateUnconsentedOutingCount(),
      this.updateShowSendMessageIncoming(),
      this.updateNonFinishedOpinionCount()
    ]).then((results: Array<any>) => {
      for (const result of results) {
        if (result instanceof SystemError) {
          console.error("error:", result);
        }
      }
    });

    return;
  }

  /**
   * ### 面会予約の未承諾があるかを取得する
   */
  public async updateUnconsentedReservationCount(): Promise<void | SystemError> {
    // 訪問予約とオンライン面会機能が使用不可の場合は即returnする
    if (userStore.facility.permittedFunctions.reservation == false && userStore.facility.permittedFunctions.onlineReservation == false) {
      this.unconsentedReservationCount = 0;
      return;
    }

    try {
      // 過去の面会予約は表示対象外にするため、開始日時を指定する
      const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000"); // 表示対象の利用者を取得する
      // ページ番号は1始まりなので、取得対象を算出するときは-1している
      let params: any = {
        start: start,
        sortKey: "datetime",
        order: "asc"
      };

      const reservations: Array<ReservationsGetModel> = await this.reservationsService.gets(userStore, params);

      let count: number = 0;
      for (const reservation of reservations) {
        if (reservation.consented == false) {
          count++;
        }
      }

      this.unconsentedReservationCount = count;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 面会予約の未承諾があるかを取得する
   */
  public async updateUnconsentedOutingCount(): Promise<void | SystemError> {
    // 機能が使用不可の場合は即returnする
    if (userStore.facility.permittedFunctions.outing == false) {
      this.unconsentedOutingCount = 0;
      return;
    }

    try {
      // 過去の外出外泊届けは表示対象外にするため、開始日時を指定する
      const start: number = this.$dateUtil.convertDateToNumber(new Date(), "yyyymmdd000000000");
      const end: number = 90000101000000000; // 終了日時は17桁で扱える大きい数字を指定する
      let params: any = {
        start: start,
        end: end
      };

      const outings: Array<OutingGetModel> = await this.outingsService.gets(userStore, params);

      // 外出外泊届けはキャンセルも取得されるので、削除されていないものだけにする
      let count: number = 0;
      for (const outing of outings) {
        if (outing.consented == false && outing.deleteFlag == false) {
          count++;
        }
      }

      this.unconsentedOutingCount = count;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### メッセージ送信の返信未読があるかを取得する
   */
  public async updateShowSendMessageIncoming(): Promise<void | SystemError> {
    try {
      const showSendMessageIncoming: SendMessageRepliesUnreadModel = await this.sendMessageRepliesService.getUnreadInFacility(userStore);
      this.showFamilySendMessageIncoming = showSendMessageIncoming.unread;

      // プランによっては施設関係者の機能を制限するので、その場合は0件として扱う
      if (PlanType.BASIC <= userStore.facility.planType) {
        const showOtherUserGroupSendMessageIncoming: SendMessageRepliesUnreadModel = await this.otherUserGroupSendMessageRepliesService.getUnreadInFacility(userStore);
        this.showOtherUserSendMessageIncoming = showOtherUserGroupSendMessageIncoming.unread;
      } else {
        this.showOtherUserSendMessageIncoming = false;
      }
    } catch (error) {
      // 配布していない問い合わせが取得できない場合は0を格納して非表示にする
      this.showFamilySendMessageIncoming = false;
      this.showOtherUserSendMessageIncoming = false;
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }

    return;
  }

  /**
   * ### 未確認の受信メッセージ数を更新する
   */
  public async updateNonFinishedOpinionCount(): Promise<void | SystemError> {
    try {
      // 家族からの連絡機能が使用不可の場合は家族からの受信メッセージは0件として扱う
      if (this.showMenu("opinion")) {
        const familyCount: number = await this.opinionsService.getCount(userStore, { confirmed: false });
        this.nonFinishedFamilyOpinionCount = familyCount;
      } else {
        this.nonFinishedFamilyOpinionCount = 0;
      }

      // プランによっては施設関係者の機能を制限するので、その場合は0件として扱う
      if (PlanType.BASIC <= userStore.facility.planType) {
        const otheruserCount: number = await this.otherUserOpinionService.getCount(userStore, { confirmed: false });
        this.nonFinishedOtherUserOpinionCount = otheruserCount;
      } else {
        this.nonFinishedOtherUserOpinionCount = 0;
      }
    } catch (error) {
      // 機能使用不可でステータスコード405が返却された場合はエラーとして扱わない
      const systemError: SystemError = error as SystemError;
      this.nonFinishedFamilyOpinionCount = 0;
      this.nonFinishedOtherUserOpinionCount = 0;

      if (systemError.statusCode == 405) {
        return undefined;
      } else {
        // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
        return error as SystemError;
      }
    }

    return;
  }

  /**
   * ### メニュー表示可否
   */
  public showMenu(functionName: string): boolean {
    // Objectのプロパティを動的参照したいが、コンパイルエラーになるのでanyにしてから取得する
    const permittedFunctions: any = userStore.facility.permittedFunctions;
    const showMenu: boolean = permittedFunctions[functionName];

    return showMenu;
  }

  /**
   * ### 一般ユーザーの機能使用可否を返す
   */
  public useFunction(key: string): boolean {
    const functions: any = userStore.user.permissions.functions;
    const used: boolean = functions[key];

    return used;
  }
}
</script>

<style lang="scss" scopeed>
@import "../../styles/mobile/_colors.scss";
#home {
  .menu-item {
    color: $font-link;
  }
  .send-message-badge {
    padding: 0 0 3px 0;
  }
}
</style>
